// Enum version of RestartPolicy
export enum RestartPolicy {
  No = 'no',
  Always = 'always',
  OnFailure = 'on-failure',
  UnlessStopped = 'unless-stopped',
}
